module.exports = __webpack_public_path__ + "static/media/Foodtopia-desktop.df2223c2.jpg";